import axios from "axios";
import firebase from "./firebase";

export const uploadAuPostcodeService = async (data) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(`${process.env.REACT_APP_UPLOAD_AU_POSTCODE}`, data, {
    headers: {
      Authorization: `Bearer ${userIdToken}`,
    },
  });
};
